module.exports = __webpack_public_path__ + "static/media/twitter.786894fa.svg";